import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <g clipPath="url(#icon-CloudMoon_svg__a)">
      <path
        fill="currentColor"
        d="M19.433 8.855q-.794.001-1.553.127a9.015 9.015 0 0 0-6.981-7.956 1.006 1.006 0 0 0-1.21 1.198c.116.525.175 1.063.178 1.595-.006 3.882-3.17 7.044-7.044 7.05a7.6 7.6 0 0 1-1.6-.178 1.005 1.005 0 0 0-1.196 1.212 9.1 9.1 0 0 0 4.068 5.664 6.5 6.5 0 0 0-1.275 3.876 6.553 6.553 0 0 0 6.545 6.545h10.07c5.274 0 9.565-4.29 9.565-9.566 0-5.275-4.29-9.566-9.566-9.566zm-16.947 4.02q.166.005.334.008c4.988-.008 9.053-4.073 9.06-9.068q0-.167-.007-.335A7 7 0 0 1 15.9 9.53a9.61 9.61 0 0 0-5.399 5.463 6.3 6.3 0 0 0-1.138-.097 6.5 6.5 0 0 0-3.776 1.205 7.1 7.1 0 0 1-3.1-3.226m16.947 13.098H9.363a4.536 4.536 0 0 1-4.53-4.531 4.537 4.537 0 0 1 4.535-4.532h.023q.297 0 .59.04a9.6 9.6 0 0 0-.114 1.47 1.007 1.007 0 1 0 2.014 0c0-4.163 3.388-7.551 7.552-7.551s7.552 3.388 7.552 7.552-3.389 7.552-7.552 7.552"
      />
    </g>
    <defs>
      <clipPath id="icon-CloudMoon_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
const SvgIconCloudMoon = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCloudMoon);
export default Memo;
